import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import InitiativeTagService from '../../services/initiative';
import { InitiativeTag } from '../../models/initiative/types';

/**
 * Type for initiative tag response
 */
export type InitiativeTagResponse = {
  id: string;
  type: string;
  attributes: InitiativeTag;
};

/**
 * Custom hook to fetch initiative tags by IDs
 *
 * @param ids - Array of initiative tag IDs to fetch
 * @returns Query result with initiative tags data
 */
export const useInitiativeTagsQuery = (
  ids?: string[],
  options?: Omit<
    UseQueryOptions<
      InitiativeTagResponse[],
      Error,
      InitiativeTagResponse[],
      string[]
    >,
    'queryKey' | 'queryFn'
  >
) => {
  const queryKey: string[] = ['initiativeTags'];
  if (ids) {
    queryKey.push(...ids);
  }
  return useQuery<InitiativeTagResponse[], Error, InitiativeTagResponse[], any>(
    {
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: queryKey,
      queryFn: async () => {
        const response = await new InitiativeTagService({ ids }).fetch();
        return response.data.data;
      },
      // Only enable the query if we have ids
      enabled: Boolean(ids && ids.length > 0),
      ...options,
    }
  );
};
